import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { store } from "@/store/store";
import { useRouter } from "vue-router";
import AgsDataService from "@/services/AgsDataService";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/abrs/Loading.vue";

import * as bootstrap from "bootstrap";
import { StreamBarcodeReader } from "vue-barcode-reader";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const serialNo = ref("");
const isLoading = ref(false);
const serialFlag = ref(false);
const videoFlag = ref(true);
const ocrError = ref(false);
const serialHead = ["06980", "07540", "07469", "07437"];

const fullWidth2HalfWidth = () => {
  return serialNo.value.replace(/[^ -~。-゜]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
}


const onDecode = (a,b,c) => {
  serialNo.value = a;
  videoFlag.value = false
}


const submitSerialNo = () => {
  isLoading.value = true;
  ocrError.value = false;
  serialFlag.value = false;
  serialNo.value = fullWidth2HalfWidth();
  serialNo.value = serialNo.value.toUpperCase();
  if(serialNo.value.length !== 11 || serialHead.indexOf(serialNo.value.substr(0,5)) === -1 ){
    serialFlag.value = true
    const modal = new bootstrap.Modal(
        document.getElementById("confirmModal")
      );
      isLoading.value = false;
      modal.show();
  } else{
  // TODO s３にあるシリアルと比較
  const formData = new FormData();
  formData.append("data", serialNo.value);
  if(serialNo.value.length < 10 ){
    serialFlag.value = true
    const modal = new bootstrap.Modal(
        document.getElementById("confirmModal")
      );
      isLoading.value = false;
      modal.show();
  } else {
  
  AgsDataService.searchNGList(formData)
    .then(async (response: ResponseData) => {
      if(response.data.data !=""){
        const modal = new bootstrap.Modal(
        document.getElementById("serialNG")
      );
      isLoading.value = false;
      modal.show();
      }
      else {
        const modal = new bootstrap.Modal(
        document.getElementById("serialOK")
      );
      isLoading.value = false;
      modal.show();
      document.addEventListener("hidden.bs.modal", function (event) {
      if (event.target.id === "serialOK") {
        store.dispatch("setSerialNo", serialNo.value);
        router.push("/postVinNumber");
      }
    });
      }
    })
    .catch(async (e: Error) => {
      isLoading.value = false;
      ocrError.value = true;
      console.log(e);
    });
  }
};
}

const inputFix = () => {
  document.getElementById("serialNo").classList.add("border");
  document.getElementById("serialNo").classList.add("border-danger");
  document.getElementById("serialNo").classList.add("border-4");
};

const __returned__ = { router, serialNo, isLoading, serialFlag, videoFlag, ocrError, serialHead, fullWidth2HalfWidth, onDecode, submitSerialNo, inputFix, Loading, StreamBarcodeReader }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})